import React from 'react'
import styles from "./FullPageLoader.module.css"
const FullPageLoader = () => {
  return (
    <div className={styles.loading}> </div>
  )
}

export default FullPageLoader